import { Pipe, PipeTransform } from '@angular/core';
import { DocumentPersonneAvertieResult } from '../../../data-domains/document-securite/entities/document-personne-avertie-result';

@Pipe({
 name: 'actionTitleForPa'
})

export class ActionTitleForPaPipe implements PipeTransform {

	transform(pa: DocumentPersonneAvertieResult, args: any[]): string {
	    let title = args[0];
		if (!pa.parcActif) {
			return 'Le parc est inactif';
		}
		switch (args[0]) {
			case 'Signer':
				if (pa.etat === 'BROUILLION') {
					title = 'Le PA est en brouillon';
				}
				break;
			case 'Générer le PDF':
				if (pa.etat === 'BROUILLION' || pa.obsolete) {
					title = 'Le PA est en brouillon ou est archivé';
				}
				break;
			default:
				// rien à faire ici
				break;
		}
		return title;
   }
   
}